// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file channel_messages.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file channel_messages.proto.
 */
export const file_channel_messages: GenFile = /*@__PURE__*/
  fileDesc("ChZjaGFubmVsX21lc3NhZ2VzLnByb3RvEgZkb21haW4iLwoVTG9naW5DbGllbnRQdWJLZXlCb2R5EhYKDmNsaWVudF9wdWJfa2V5GAEgASgMIj0KHExvZ2luQXV0aGVudGljYXRvclB1YktleUJvZHkSHQoVYXV0aGVudGljYXRvcl9wdWJfa2V5GAIgASgMIjIKF0xvZ2luSGFzaENvbW1pdG1lbnRCb2R5EhcKD2hhc2hfY29tbWl0bWVudBgDIAEoDCJOChhMb2dpbkVuY3J5cHRlZFNlY3JldEJvZHkSGAoQZW5jcnlwdGVkX3NlY3JldBgBIAEoDBIYChBhdXRoZW50aWNhdG9yX2lkGAIgASgJQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from message domain.LoginClientPubKeyBody
 */
export type LoginClientPubKeyBody = Message<"domain.LoginClientPubKeyBody"> & {
  /**
   * @generated from field: bytes client_pub_key = 1;
   */
  clientPubKey: Uint8Array;
};

/**
 * Describes the message domain.LoginClientPubKeyBody.
 * Use `create(LoginClientPubKeyBodySchema)` to create a new message.
 */
export const LoginClientPubKeyBodySchema: GenMessage<LoginClientPubKeyBody> = /*@__PURE__*/
  messageDesc(file_channel_messages, 0);

/**
 * @generated from message domain.LoginAuthenticatorPubKeyBody
 */
export type LoginAuthenticatorPubKeyBody = Message<"domain.LoginAuthenticatorPubKeyBody"> & {
  /**
   * @generated from field: bytes authenticator_pub_key = 2;
   */
  authenticatorPubKey: Uint8Array;
};

/**
 * Describes the message domain.LoginAuthenticatorPubKeyBody.
 * Use `create(LoginAuthenticatorPubKeyBodySchema)` to create a new message.
 */
export const LoginAuthenticatorPubKeyBodySchema: GenMessage<LoginAuthenticatorPubKeyBody> = /*@__PURE__*/
  messageDesc(file_channel_messages, 1);

/**
 * @generated from message domain.LoginHashCommitmentBody
 */
export type LoginHashCommitmentBody = Message<"domain.LoginHashCommitmentBody"> & {
  /**
   * @generated from field: bytes hash_commitment = 3;
   */
  hashCommitment: Uint8Array;
};

/**
 * Describes the message domain.LoginHashCommitmentBody.
 * Use `create(LoginHashCommitmentBodySchema)` to create a new message.
 */
export const LoginHashCommitmentBodySchema: GenMessage<LoginHashCommitmentBody> = /*@__PURE__*/
  messageDesc(file_channel_messages, 2);

/**
 * @generated from message domain.LoginEncryptedSecretBody
 */
export type LoginEncryptedSecretBody = Message<"domain.LoginEncryptedSecretBody"> & {
  /**
   * @generated from field: bytes encrypted_secret = 1;
   */
  encryptedSecret: Uint8Array;

  /**
   * @generated from field: string authenticator_id = 2;
   */
  authenticatorId: string;
};

/**
 * Describes the message domain.LoginEncryptedSecretBody.
 * Use `create(LoginEncryptedSecretBodySchema)` to create a new message.
 */
export const LoginEncryptedSecretBodySchema: GenMessage<LoginEncryptedSecretBody> = /*@__PURE__*/
  messageDesc(file_channel_messages, 3);

